import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface RecordLimitBlockProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  maxRecordCount: number;
}

export function RecordLimitBlock({
  open,
  onOpenChange,
  maxRecordCount,
}: RecordLimitBlockProps) {
  if (maxRecordCount === 0) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>Record limit reached</DialogTitle>
          <DialogDescription>
            This project has reached its {maxRecordCount} photo limit. Delete
            existing photos to make room, or contact support to raise the
            limit.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Got it</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
